import { useState } from "react";
import { Eye, EyeSlash as EyeOff } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAddByokKey } from "../hooks";
import type { ProviderId } from "../types";

interface AddKeyFormProps {
  provider: ProviderId;
  /** Provider-specific human placeholder (e.g. "sk-..."). */
  placeholder: string;
  onAdded?: () => void;
}

export function AddKeyForm({ provider, placeholder, onAdded }: AddKeyFormProps) {
  const [key, setKey] = useState("");
  const [show, setShow] = useState(false);
  const add = useAddByokKey();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!key.trim()) return;
    await add.mutateAsync({ provider, key: key.trim() });
    setKey("");
    onAdded?.();
  };

  const inputId = `byok-key-${provider}`;
  return (
    <form onSubmit={submit} className="space-y-3" aria-label={`Adicionar chave ${provider}`}>
      <Label htmlFor={inputId}>Cole sua chave</Label>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Input
            id={inputId}
            type={show ? "text" : "password"}
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder={placeholder}
            autoComplete="off"
            spellCheck={false}
            disabled={add.isPending}
          />
          <button
            type="button"
            onClick={() => setShow((v) => !v)}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            aria-label={show ? "Esconder chave" : "Mostrar chave"}
          >
            {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
        <Button type="submit" disabled={!key.trim() || add.isPending}>
          {add.isPending ? "Salvando..." : "Salvar"}
        </Button>
      </div>
    </form>
  );
}
